<template>
  <div class="tags" v-if="showTags">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-cls">
      <el-breadcrumb-item v-if="getUser.hasSiteBind && !getUser.isSecurityAuditor"
                          :to="{ name: 'businessHome' }"
                          class="breadcrumb-home-item">
        <img src="@/assets/img/icon-menu1-2.svg" class="menu-icon-cls" width="100%"/>
        <img src="@/assets/img/icon-menu1-3.svg" class="menu-icon-hover-cls" width="100%"/>
        <span>{{$t('home')}}</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item,index) in routes"
                          :key="index"
                          :to="{ name:item }">
            {{$t(getRouteByName(item).meta.title)}}
            <GuidanceTooltip v-if="item == 'settingHome' && getUser.userType == '1'" class="tip-icon" :content="$t('settingHomeTipHtml')" :size="18" :iconSize="14" :jumpLink="$t('settingHomeTipLink')"></GuidanceTooltip>
            <GuidanceTooltip v-if="item == 'insights'" class="tip-icon" :content="$t(`kee_video_tip_${getUser.userType}`)" :size="18" :iconSize="14" :jumpLink="$t(`kee_video_link_${getUser.userType}`)"></GuidanceTooltip>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <span v-if="showClientName" class="tags-client-name-hint" :title="getSite.clientName">
      {{ $t('FORM_LABEL_clientName') }}:
      <span style="font-weight: bolder; color: #00338D">{{ getSite.clientName }}</span>
    </span>
    <el-popover v-if="getUser.userType === '1'" placement="bottom" trigger="hover" :popper-class="getPopperClass">
      <div class="engagement-slot-info">
          <span>{{ $t('site_code') }}: <span class="font-bold">{{ engagementInfo.code || '-' }}</span></span>
          <span>{{ $t('site_type') }}: <span class="font-bold">{{ engagementInfo.type || '-' }}</span></span>
          <span>{{ $t('site_status')}}: <span class="font-bold">{{ engagementInfo.status || '-' }}</span></span>
          <span v-if="engagementInfo.rollForWardFlag === true">{{ $t('code_closed_time')}}: <span class="font-bold">{{ engagementInfo.codeClosedTime | formatDate}}</span></span>
        <div class="warning" v-html="engagementInfo.notice" />
      </div>
      <div class="engagement-info" v-show="$route.path === '/client'" slot="reference">
        <div :class="['info-text-area', 'animation-'+ engagementInfo.animationTimeType]" v-if="false">
          <span>{{ $t('site_code') }}:{{ engagementInfo.code || '-' }}</span>
          <span>{{ $t('site_type') }}:{{ engagementInfo.type || '-' }}</span>
          <span>{{ $t('site_status')}}:{{ engagementInfo.status || '-' }}</span>
          <span class="warning" v-html="engagementInfo.notice" />
        </div>
        <div class="attention-tips">
          <svg-icon icon-name="information" icon-color="#fd349c" :size="16" ></svg-icon>
          {{siteTips}}
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import bus from './bus';
import { mapGetters } from 'vuex';
import API from '@/api'
import Vue from 'vue'
import GuidanceTooltip from '@/components/common/GuidanceTooltip'
import SvgIcon from '@/components/svgIcon/index'

export default {
  components: { GuidanceTooltip, SvgIcon },
    data() {
        return {
            tagsList: [],
            //历史原因 写死面包屑导航配置
            routerMatch: {
                client: ['client'],
                pbc: ['client', 'pbc'],
                exchange: ['client', 'exchange'],
                ita: ['client', 'exchange', 'ita'],
                confirmation: ['client', 'confirmation'],
                insights: ['client', 'insights'],
                group: ['client', 'group'],
                courseList: ['client', 'insights', 'courseList'],
                csConsult: ['client', 'insights', 'csConsult'],
                myCourse: ['client', 'insights', 'myCourse'],
                courseDetail: ['client', 'insights', 'courseList', 'courseDetail'],
                accounts: ['client', 'accounts'],
                matterLogs: ['client', 'matterLogs'],
                newPbcList: ['client', 'pbc', 'newPbcList'],

                system: ['system'],
                user: ['system', 'user'],
                sysAdmin: ['system', 'sysAdmin'],
                site: ['system', 'site'],
                news: ['system', 'news'],
                masterData: ['system', 'masterData'],
                securityAuditor: ['system','securityAuditor'],

                auditTrail: ['auditTrail'],

                settingHome: ['settingHome'],
                general: ['settingHome', 'general'],
                clientRoles: ['settingHome', 'clientRoles'],
                clientUsers: ['settingHome', 'clientUsers'],
                kpUserRole: ['settingHome', 'kpUserRole'],
                kpmgTeamMember: ['settingHome', 'kpmgTeamMember'],
                toNextYear: ['settingHome', 'toNextYear'],
                clientDownloaded: ['settingHome', 'clientDownloaded'],
                groupReportingRole: ['settingHome', 'groupReportingRole'],
                groupReportingUser: ['settingHome', 'groupReportingUser'],
                admin:['client','admin']


            },
          engagementInfo: {
            code: '',
            type: '',
            status: '',
            notice: '',
            animationTimeType: null
          },
          codeTypeMap: {
            0: this.$t('site_code_type_long_master'),
            1: this.$t('site_code_type_long_sub'),
            2: this.$t('site_code_type_long_opp'),
            3: this.$t('site_code_type_long_bd')
          },
          statusMap: {
            true: this.$t('site_close_yes'),
            false: this.$t('site_close_no')
          },
          scrollTimer: null,
          siteTips:''
        };
    },
    methods: {
      onLightClick() {
        window.open('https://kpmgcn.mediaspace.sg.kaltura.com/media/0_6xc0v6dk')
      },
      getEngagementCode() {
        if(this.getUser.userType === '1' && this.getUser.isSecurityAuditor) {
          return
        }
        API.general.siteInfo({siteId: this.getSite.siteId}).then((res) => {
          if(res.code === '1') {
            const codeType = this.codeTypeMap[res.data.codeType]
            const status = this.statusMap[res.data.rollForWardFlag]

            let notice = ''
            let animationTimeType = null
            if (res.data.rollForWardFlag) {
              notice = this.$t('roll_forward_notice_1', {date: res.data.actionTime, code: res.data.codeId})
              animationTimeType = 1
              this.siteTips = this.$t('siteTips2')
            } else {
              if (['2', '3'].includes(res.data.codeType)) {
                notice = this.$t('roll_forward_notice_2', {code: res.data.codeId, codeType: codeType})
                animationTimeType = 2
                this.siteTips = this.$t('siteTips3')
              } else if (['0', '1'].includes(res.data.codeType)) {
                notice = this.$t('roll_forward_notice_3', {code: res.data.codeId})
                animationTimeType = 3
                this.siteTips = this.$t('siteTips1')
              }
            }
            this.engagementInfo = {
              code: res.data.codeId,
              type: codeType,
              status: status,
              notice: notice,
              animationTimeType: animationTimeType,
              rollForWardFlag: res.data.rollForWardFlag,
              codeClosedTime: res.data.codeCloseDatetime
            }
            sessionStorage.setItem('siteFlag', res.data.siteFlag)
            this.$store.commit('common/setIfKpHasAccess', res.data.ifKpHasAccess)
          } else {
            this.$message.error(this.$t(res.code))
          }
        })
      },
        getRouteByName(name) {
            let _data = this.$router.options.routes,
                matched = {};
            const _find = function(data) {
                for (let i = 0; i < data.length; i++) {
                    let hasChildren = _.isArray(data[i].children);
                    if (data[i].name === name) {
                        matched = data[i];
                        return;
                    } else {
                        if (hasChildren && data[i].children.length > 0) {
                            _find(data[i].children);
                        }
                    }
                }
            };
            _find(_data);

            return matched;
        },
        isActive(path) {
            return path === this.$route.fullPath;
        },
        // 关闭单个标签
        closeTags(index) {
            const delItem = this.tagsList.splice(index, 1)[0];
            const item = this.tagsList[index] ? this.tagsList[index] : this.tagsList[index - 1];
            if (item) {
                delItem.path === this.$route.fullPath && this.$router.push(item.path);
            } else {
                this.$router.push('/');
            }
        },
        // 关闭全部标签
        closeAll() {
            this.tagsList = [];
            this.$router.push('/');
        },
        // 关闭其他标签
        closeOther(index) {
            this.tagsList.splice(index + 1, this.tagsList.length - index - 1);
        },
        // 设置标签
        setTags(route) {
            const isExist = this.tagsList.some(item => {
                return item.path === route.fullPath;
            });
            if (!isExist) {
                if (this.tagsList.length >= 8) {
                    this.tagsList.shift();
                }
                this.tagsList.push({
                    title: route.meta.title,
                    path: route.fullPath,
                    name: route.matched[1].components.default.name
                });
            }
            bus.$emit('tags', this.tagsList);
        },
        handleTags(command) {
            command === 'other' ? this.closeOther() : this.closeAll();
        }
    },
    computed: {
        showTags() {
            return this.tagsList.length > 0;
        },
        showClientName() {
            const routerArray = this.routerMatch[this.$route.name] || [];
            return !routerArray.some(item => item === 'system') && !this.getUser.isSecurityAuditor;
        },
        getPopperClass() {
            return this.$i18n.locale === 'zh' ? 'tag-engagement-popper-cls' : 'tag-engagement-popper-cls-en';
        },
        routes() {
            return this.routerMatch[this.$route.name];
        },
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite'
        })
    },
    watch: {
        $route(newValue, oldValue) {
            this.setTags(newValue);
            // 更新站点的engagementInfo信息
            if(newValue.name === 'client') {
              this.getEngagementCode()
            }
        }
    },
    created() {
      if(this.$route.name === 'client') {
        this.getEngagementCode()
      }
      this.setTags(this.$route);
      // 监听关闭当前页面的标签页
      bus.$on('close_current_tags', () => {
          for (let i = 0, len = this.tagsList.length; i < len; i++) {
              const item = this.tagsList[i];
              if (item.path === this.$route.fullPath) {
                  if (i < len - 1) {
                      this.$router.push(this.tagsList[i + 1].path);
                  } else if (i > 0) {
                      this.$router.push(this.tagsList[i - 1].path);
                  } else {
                      this.$router.push('/');
                  }
                  this.tagsList.splice(i, 1);
                  break;
              }
          }
      });
    }
};
</script>


<style scoped>
.attention-tips {
  color:#fd349c;
}
.font-bold {
  font-weight: bold;
}
.tags {
    display: flex;
    align-items: center;
    z-index: 99;
    position: relative;
    overflow: hidden;
    background: #fff;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    padding: 0 15px 0 15px;
    box-shadow: 0px 3px 2px rgba(215, 215, 215, 0.349019607843137);
    -webkit-box-shadow: 0px 3px 2px rgba(215, 215, 215, 0.349019607843137);
    border-top: 1PX solid rgba(240, 240, 240, 1);
}
.breadcrumb-cls{
    height: 100%;
    display: flex;
    align-items: center;
    line-height: 1.2 !important;
}
.tags ::v-deep .el-breadcrumb__inner a,
.tags ::v-deep .el-breadcrumb__inner.is-link{
    display: flex;
    align-items: center;
    height: 100%;
    color: #00338d;
    font-size: 12PX;
}
.tags ::v-deep .el-breadcrumb__inner a:hover,
.tags ::v-deep .el-breadcrumb__inner.is-link:hover {
  color: #3879eb;
}
.tags ::v-deep .el-breadcrumb__inner.is-link:hover .menu-icon-cls{
    display: none;
}
.tags ::v-deep .el-breadcrumb__inner.is-link:hover .menu-icon-hover-cls{
    display: inline-block;
}
.tip-icon {
  margin-left: 5px;
}
.breadcrumb-cls ::v-deep .el-breadcrumb__item{
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  color: #81848a;
  font-size: 12PX;
}
.menu-icon-cls{
    margin-right: 4px;
    width: 14PX;
}
.menu-icon-hover-cls{
    display: none;
    margin-right: 4px;
    width: 14PX;
}
.tags ul {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 7px 0 0 40px;
}

.breadcrumb {
    display: inline-block;
    font-size: 18px;
}

.tags-li:not(.active):hover {
    background: #f8f8f8;
}

.tags-li.active {
    color: #fff;
}

.tags-li-title {
    float: left;
    max-width: 130px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-right: 5px;
    color: #666;
}

.tags-li.active .tags-li-title {
    color: #333;
}

.tags-client-name-hint {
  color: rgb(96, 98, 102);
  font-size: 12PX;
  margin-left: auto;
  width: 600px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
}
  .engagement-info{
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: inline-block;
    height: 45px;
    overflow: hidden;
  }

.info-text-area {
  position: absolute;
  left: 100%;
  top: 0;
  width: fit-content;
  width: -moz-fit-content;
  height: 45px;
  line-height: 45px;
  font-size: 12PX;
  white-space: nowrap;
  transform: translateX(-100%);
  animation: moving 40s linear infinite;
}
.info-text-area.animation-1{
  animation: moving 50s linear infinite;
}
.info-text-area.animation-2{
  animation: moving 40s linear infinite;
}
.info-text-area.animation-3{
  animation: moving 30s linear infinite;
}
.info-text-area:hover{
  animation-play-state:paused;
}
.info-text-area>span,
.engagement-slot-info > span{
  border-right: 1px solid #e2e2e9;
  padding-right: 10px;
  margin-right: 10px;
}
.engagement-slot-info > span:nth-child(4){
  border:0;
}

.info-text-area .warning,
.engagement-slot-info .warning{
  color: #3879eb;
}
@keyframes moving {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% - 770px));
  }
}
</style>
<style>
.tag-engagement-popper-cls{
  border-radius: 5px !important;
  width: 800px;
}
.tag-engagement-popper-cls-en{
  border-radius: 5px !important;
  width: 900px;
}
</style>
